import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost } from "@/lib/api-client";

interface AdminVenueActionResponse {
  venue?: {
    id: string;
    name: string;
    status: string;
  };
  deleted?: boolean;
  venueId?: string;
  deletedCounts?: {
    leaderboards: number;
    entries: number;
    subscriptions: number;
  };
}

export function useSuspendVenue() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (venueId: string) => {
      const response = await apiPost<AdminVenueActionResponse>(
        `/admin/venues/${venueId}/suspend`
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-venues"] });
    },
  });
}

export function useUnsuspendVenue() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (venueId: string) => {
      const response = await apiPost<AdminVenueActionResponse>(
        `/admin/venues/${venueId}/unsuspend`
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-venues"] });
    },
  });
}

export function useDeleteVenue() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (venueId: string) => {
      const response = await apiPost<AdminVenueActionResponse>(
        `/admin/venues/${venueId}/delete`
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-venues"] });
    },
  });
}
